var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20.58,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.2903C21.5 15.6665 16.8309 20.0806 11 20.0806C5.16908 20.0806 0.5 15.6665 0.5 10.2903C0.5 4.91416 5.16908 0.5 11 0.5C16.8309 0.5 21.5 4.91416 21.5 10.2903Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.588 14L7.24 10.256L4.564 6.464H5.692L7.864 9.536L9.856 6.464H10.996L8.38 10.244L11.092 14H9.94L7.756 10.988L5.716 14H4.588ZM11.8792 14L14.5312 10.256L11.8552 6.464H12.9832L15.1552 9.536L17.1472 6.464H18.2872L15.6712 10.244L18.3832 14H17.2312L15.0472 10.988L13.0072 14H11.8792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXx);
export default __webpack_public_path__ + "static/media/XX.3d5a7a6754e3d2714e5eb389ce8fa640.svg";
export { ForwardRef as ReactComponent };